import React from 'react';
import OpenInNewIcon from '../IconFont/OpenInNewIcon';

export default function OpenNewTab({href, title = null}) {
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
        >
            {
                title ? (
                    <>
                        {title}
&nbsp;
                    </>
                ) : null
            }
            <OpenInNewIcon />
        </a>
    );
}
